<template lang="pug">
  div(class="wrapper")
    div(class="tags-wrapper")
      e-document-tag(
        v-for="tag in item.tags"
        :key="tag.id"
        :name="tag.name"
      )
    nuxt-link(
      :to="`/documents/${item.id}`"
      class="d-flex align-center"
      :data-test="`document-title-${rowIndex}`"
    )
      span(
        class="document-title text-12px light"
        :title="value"
      ) {{ value }}
</template>

<script>
import EDocumentTag from '~/modules/tags/components/e-document-tag'

export default {
  name: 'EDocumentTitleWithTags',
  components: { EDocumentTag },
  props: {
    value: {
      type: String,
      default: null
    },
    item: {
      type: Object,
      default: () => ({})
    },
    rowIndex: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}

.tags-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 8px;
}

.document-title {
  display: inline-block;
  max-width: 150px;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline;
  color: #2f80ed;

  @media (min-width: map-get($breakpoints, 'lg')) {
    max-width: 300px;
  }

  @media (min-width: map-get($breakpoints, 'xl')) {
    max-width: 100%;
  }
}
</style>
